import { render, staticRenderFns } from "./LensInspirationView.vue?vue&type=template&id=64a30800&scoped=true"
import script from "./LensInspirationView.vue?vue&type=script&lang=js"
export * from "./LensInspirationView.vue?vue&type=script&lang=js"
import style0 from "./LensInspirationView.vue?vue&type=style&index=0&id=64a30800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a30800",
  null
  
)

export default component.exports